module.exports = __webpack_public_path__ + "static/media/ggg.f08ad05f.png";